// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"418":"e0227a49","2963":"c8c9ca38","3886":"c8c9ca38","7936":"c8c9ca38","9663":"597c6112"}[chunkId] + ".chunk.css";
};